import utils       from '../../../utils'   ;
import customAxios from '../../customAxios';

import { FIND_USER            } from '../../routes'                   ;
import { IFindUserInformation } from '../../../types/common.interface';

async function findDriver(props: IFindUserInformation): Promise<any> {
  let thisUrl: string = FIND_USER + '?';
  if (props.page ) thisUrl += `page=${props.page}`   ;
  if (props.limit) thisUrl += `&limit=${props.limit}`;

  const populateFields =
    "schoolDriverInformation.favorite.neighborhood fatherName birthday schoolDriverInformation.isArchived schoolDriverInformation.isNew schoolDriverInformation.favorite.school blocks financial companyInformation schoolDriverInformation.approved schoolDriverInformation.documents schoolDriverInformation.province schoolDriverInformation.companyName schoolDriverInformation.marital schoolDriverInformation.company schoolDriverInformation.tagNumber schoolDriverInformation.fileNumber schoolDriverInformation.formNumber schoolDriverInformation.city schoolDriverInformation.address schoolDriverInformation.town schoolDriverInformation.neighborhood driverInformation.plateNumber driverInformation.financialGroup gender driverInformation.subscriptionExpireAt driverInformation.nationalCode driverInformation.driverLicenseNumber driverInformation.insuranceNumber driverInformation.address driverInformation.uniqueCodeThirdPartyInsurance driverInformation.approved driverInformation.carBrand driverInformation.carModel driverInformation.carColor driverInformation.carSystem driverInformation.insuranceExpiryDate driverInformation.vin avatar";

  thisUrl += `&populate=${populateFields}`;

  let schoolDriverInformation;
  if (props.companyId) {
    schoolDriverInformation = {
      "schoolDriverInformation.company": props.companyId,
    };
  }

  let body: any = {
    query: {
      userTypes: {
        $in: ["DRIVER"],
      },
      ...schoolDriverInformation,
    },
    isSchoolDriver: true,
  };

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    if (props?.search?.base === "driverInformation.nationalCode") {
      body = {
        query: {
          ...body.query,
          "driverInformation.nationalCode": { $regex: props?.search?.value },
        },
      };
    } else {
      body = {
        query: {
          ...body.query,
          [String(props.search.base)]: utils.convertNumbers2English(
            props.search.value
          ),
        },
      };
    }
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  if (props?.filters) {
    const { province, city, company, marital, gender, haveTagNumber } = props.filters;

    body = {
      query: {
        ...body.query,
        "schoolDriverInformation.province": province?._id,
        "schoolDriverInformation.approved.isApproved": props?.filters?.approved,
        "schoolDriverInformation.city": city?._id,
        "schoolDriverInformation.company": company?._id,
        // "schoolDriverInformation.tagNumber": haveTagNumber ? {$exists: true, $ne: 0} : {$exists: true, $ne: 0},
        gender: gender?.value,
        "schoolDriverInformation.marital": marital?.value,
        "parentInformation.isArchived": props?.filters?.isArchive,
      },
    }; // if (province) query({ target: "province", value: province?._id });
    // if (city) query({ target: "city", value: city?._id });
    // if (company) query({ target: "company", value: company?._id });
    // if (marital) query({ target: "marital", value: marital?.value });
    // if (gender) query({ target: "gender", value: gender?.value });
  }

  // ?? Academic year (سال تحصیلی) scope. Set last, and on the body root rather than inside `query`, because the
  // ?? search and filter branches above rebuild `body` wholesale and would otherwise drop it.
  if (props.academicYear) body.academicYear = props.academicYear;
  if (props.includePreviousYear) body.includePreviousAcademicYear = true;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default findDriver;
